import { render } from "./ExcelReferencesTable.vue?vue&type=template&id=784555a0&scoped=true"
import script from "./ExcelReferencesTable.vue?vue&type=script&lang=js"
export * from "./ExcelReferencesTable.vue?vue&type=script&lang=js"

import "./ExcelReferencesTable.vue?vue&type=style&index=0&id=784555a0&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784555a0"]])

export default __exports__